// ** Third Party Imports
import styled from 'styled-components'

export const CheckboxRoot = styled.div`
	display: flex;
	align-items: start;
	padding: 0.25rem 0 0 0;
`

export const StyledInput = styled.input`
	position: relative;
	border: 2px solid ${({ theme }) => theme.pallette.text.black75};
	border-radius: 4px;

	background: none;
	cursor: pointer;
	line-height: 0;
	outline: 0;
	padding: 0 !important;
	vertical-align: text-top;
	height: 1.25rem;
	width: 1.25rem;
	-webkit-appearance: none;

	&:checked {
		border: 2px solid ${({ theme }) => theme.pallette.success.main};
		background-color: ${({ theme }) => theme.pallette.primary.main};
		&:before {
			content: '';
			position: absolute;
			right: 50%;
			top: 50%;
			width: 3px;
			height: 6px;
			border: solid ${({ theme }) => theme.pallette.geniiWhite};
			border-width: 0 2px 2px 0;
			margin: -1px -1px 0 0;
			transform: rotate(45deg) translate(-50%, -50%);
			z-index: 2;
		}
	}
`

export const SmallStyledInput = styled.input`
	position: relative;
	border: 1.5px solid ${({ theme }) => theme.pallette.text.black50};
	border-radius: 3px;

	background: none;
	cursor: pointer;
	line-height: 0;
	outline: 0;
	padding: 0 !important;
	vertical-align: text-top;
	height: 1rem;
	width: 1rem;
	flex-shrink: 0;
	-webkit-appearance: none;

	&:checked {
		border: 1.5px solid ${({ theme }) => theme.pallette.gray.strong};
		background-color: ${({ theme }) => theme.pallette.gray.strong};
		&:before {
			content: '';
			position: absolute;
			right: 50%;
			top: 50%;
			width: 2px;
			height: 4px;
			border: solid ${({ theme }) => theme.pallette.geniiWhite};
			border-width: 0 1.5px 1.5px 0;
			margin: 0px -1px 1px 0px;
			transform: rotate(45deg) translate(-50%, -50%);
			z-index: 2;
		}
	}
`

export const CheckboxLabel = styled.label`
	color: ${({ theme }) => theme.pallette.text.black};
	font-size: 1rem;
	font-weight: 400;
`

export const SmallCheckboxLabel = styled.label`
	color: ${({ theme }) => theme.pallette.text.black50};
	font-size: 0.6875rem;
	font-weight: 400;
	line-height: 1.3;
	word-break: break-word;
	overflow-wrap: break-word;
`

export const TextContainer = styled.div`
	margin-left: 0.5rem;
	display: flex;
	flex-direction: column;
`
